import { render, staticRenderFns } from "./SelectMerchantCombo.vue?vue&type=template&id=22d52a60&scoped=true"
import script from "./SelectMerchantCombo.vue?vue&type=script&lang=js"
export * from "./SelectMerchantCombo.vue?vue&type=script&lang=js"
import style0 from "./SelectMerchantCombo.vue?vue&type=style&index=0&id=22d52a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d52a60",
  null
  
)

export default component.exports